import { IFilterElement } from "@saleor/components/Filter";
import { maybe, parseBoolean } from "@saleor/misc";
import {
  SubscriberFilterKeys,
  SubscriberListFilterOpts
} from "@saleor/subscribers/components/SubscriberListPage";
import {
  SubscriberListUrlFilters,
  SubscriberListUrlFiltersEnum,
  SubscriberListUrlQueryParams
} from "@saleor/subscribers/urls";
import { SubscriptionFilterInput } from "@saleor/types/globalTypes";
import {
  createFilterTabUtils,
  createFilterUtils,
  getSingleValueQueryParam
} from "@saleor/utils/filters";

export const ATTRIBUTE_FILTERS_KEY = "subscriberFilters";

export function getFilterOpts(
  params: SubscriberListUrlFilters
): SubscriberListFilterOpts {
  return {
    active: {
      active: params.active !== undefined,
      value: maybe(() => parseBoolean(params.active, true))
    }
  };
}

export function getFilterVariables(
  params: SubscriberListUrlFilters
): SubscriptionFilterInput {
  return {
    isSubscription:
      params.active !== undefined
        ? parseBoolean(params.active, false)
        : undefined,
    search: params.query
  };
}

export const {
  deleteFilterTab,
  getFilterTabs,
  saveFilterTab
} = createFilterTabUtils<SubscriberListUrlFilters>(ATTRIBUTE_FILTERS_KEY);

export const { areFiltersApplied, getActiveFilters } = createFilterUtils<
  SubscriberListUrlQueryParams,
  SubscriberListUrlFilters
>(SubscriberListUrlFiltersEnum);

export function getFilterQueryParam(
  filter: IFilterElement<SubscriberFilterKeys>
): SubscriberListUrlFilters {
  const { name } = filter;

  switch (name) {
    case SubscriberFilterKeys.active:
      return getSingleValueQueryParam(
        filter,
        SubscriberListUrlFiltersEnum.active
      );
  }
}
